<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">

          <PageHeader showBreadcrumbs page-title="Finance reports - invoices">
            <template #buttons>
              <b-button class="button title-container__controls-item" :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter">
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
              <b-button v-if="$can(permissions.CreateFinancesInvoices)" variant="success" class="button"
                @click="showCreateInvoices" :disabled="isDataPageLoading">
                Create
              </b-button>
            </template>
          </PageHeader>
          <Filters v-show="isShowFilter" textButtonSubmit="Get Report" :data="filters" resetToInitial
            :isLoading="isDataPageLoading" @submit="getReportsByFilter" />

          <div v-if="isDataPageLoading && isShowFilter" class="content-loading-wrapper">
            <Preloader class="centered-preloader" />
          </div>

          <TableForPage ref="table" style="margin-bottom: 0;" v-if="reports.length" :tableData="reports"
            :fields="getFieldsReports" :slots="fieldsReportsSlot" :totalItems="totalReports"
            :totalFields="getFieldsReportsTotal" :tableDescription="columnDescription" showTopControls showTotalTable>
            <template v-slot:tableControlsRight>
              <b-button class="ml-auto" size="sm" @click="showColumns = !showColumns">
                <span v-if="showColumns">Hide</span>
                <span v-else>Show</span>
                RUB/GBP columns
              </b-button>
            </template>
            <template v-slot:specialist="slotProps">
              <div class="specialist-user-name">
                {{ slotProps.item.business_developer.name }}
              </div>
              <div class="specialist-user-position">
                {{ slotProps.item.business_developer.position }}
              </div>
            </template>
            <template v-slot:row="slotProps">
              <NestedTable :items="slotProps.row.item.projects" :fields="getFieldsReportsNested"
                :perPage="slotProps.row.item.projects.length" :modalFields="getFieldsReportsInvoices"
                :modalSlots="slotsInvoices" :disabledMore="disabledModalShowingButton" rowName="invoices">
                <template v-slot:modal-invoice_status.name="slotProps">
                  <LabelTableStatus :status="slotProps.item.invoice_status" />
                </template>
                <template v-slot:modal-invoice_type.type="slotProps">
                  <LabelInvoiceType :type="slotProps.item.invoice_type" />
                </template>
                <template v-slot:modal-invoice_number="slotProps">
                  <LabelDocDownloadLink :file_name="slotProps.item.file_name" :url="slotProps.item.preview_url" />
                </template>
                <template v-slot:modal-buttonShow="slotProps">
                  <div>
                    <b-button size="sm" class="button btn-icon" variant="secondary"
                      :disabled="disabledModalShowingButton(slotProps)" @click="showDetails(slotProps)">
                      <span class="material-icons">
                        {{ slotProps.detailsShowing ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </span>
                    </b-button>
                  </div>
                </template>
                <template v-slot:modal-row="slotProps">
                  <NestedTable v-if="slotProps.row.item.invoice_type.id === 1" :items="slotProps.row.item.items"
                    :fields="fieldsReportsItems" :slots="slotsItems" :buttonShow="false" :showTotalTable="false">
                    <template v-slot:specialist="slotProps">
                      <div class="specialist-user-name">
                        {{ slotProps.item.user.name }}
                      </div>
                      <div class="specialist-user-position">
                        {{ slotProps.item.user.position }}
                      </div>
                    </template>
                  </NestedTable>
                  <NestedTable v-else-if="slotProps.row.item.invoice_type.id === 2" :items="slotProps.row.item.periods"
                    :fields="fieldsReportsPeriods" :slots="slotsPeriods" :buttonShow="false" :showTotalTable="false">
                    <template v-slot:specialist="slotProps">
                      <div class="specialist-user-name">
                        {{ slotProps.item.user.name }}
                      </div>
                      <div class="specialist-user-position">
                        {{ slotProps.item.user.position }}
                      </div>
                    </template>
                    <template v-slot:period="slotProps">
                      {{ slotProps.item.date_from }} - {{ slotProps.item.date_to }}
                    </template>
                  </NestedTable>
                  <NestedTable v-else-if="slotProps.row.item.invoice_type.id === 3"
                    :items="slotProps.row.item.specialisations" :fields="fieldsReportsSpecialisations"
                    :buttonShow="false" :showTotalTable="false"></NestedTable>
                  <strong v-if="slotProps.row.item.extra_payments.length">Extra payments</strong>
                  <NestedTable v-if="slotProps.row.item.extra_payments.length"
                    :items="slotProps.row.item.extra_payments" :fields="fieldsReportsExtraPayments" :buttonShow="false"
                    :showTotalTable="false"></NestedTable>
                </template>
              </NestedTable>
            </template>
          </TableForPage>
        </div>
        <FinanceInvoicesForm v-model="invoiceFormData.show" :mode="invoiceFormData.mode" :data="invoiceFormData.form"
          :title="invoiceFormData.title" :headerTitle="invoiceFormData.headerTitle"
          :submitButtonText="invoiceFormData.submitButtonText"
          :bankDetails="getOwnBankDetails" :templates="getTemplates" :projects="getActualProjects"
          :statuses="getStatuses" :types="getInvoicesTypes"
          @submit="saveFinanceInvoices" @loadingChange="handleInvoiceFormLoadingChange" ref="financeInvoicesForm" />
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { permissions } from '@mocks/permissions'
import TableForPage from '@tables/TableForPage'
import Filters from '@components/Filter/Filter'
import NestedTable from '@tables/NestedTable'
import LabelTableStatus from '@components/tables/elements/LabelTableStatus'
import LabelInvoiceType from '@components/tables/elements/LabelInvoiceType'
import LabelDocDownloadLink from '@components/tables/elements/LabelDocDownloadLink'
import FinanceInvoicesForm from '@components/modals/FinanceInvoicesForm/FinanceInvoicesForm.vue'
import InvoiceFormModal from '../mixins/InvoiceFormModal'
import PageHeader from '@components/PageHeader.vue'
import Preloader from '@components/Preloader'

export default {
  name: 'FinanceReports',
  mixins: [ InvoiceFormModal ],
  components: {
    FinanceInvoicesForm,
    Filters,
    TableForPage,
    NestedTable,
    LabelTableStatus,
    LabelInvoiceType,
    LabelDocDownloadLink,
    PageHeader,
    Preloader
  },
  data () {
    return {
      permissions: permissions,
      isShowFilter: true,
      showColumns: false,
      filters: {
        'date_from': {
          type: 'datepicker',
          name: 'date_from',
          label: 'Date from',
          format: 'dd/MM/yyyy',
          validation: [
            { name: 'required' }
          ],
          value: moment().subtract(1, 'months').startOf('month').toISOString(),
          defaultValue: moment().subtract(1, 'months').startOf('month').toISOString(),
          class: 'col-md-2'
        },
        'date_to': {
          type: 'datepicker',
          name: 'date_to',
          label: 'Date to',
          format: 'dd/MM/yyyy',
          validation: [
            { name: 'required' }
          ],
          value: moment().subtract(1, 'months').endOf('month').toISOString(),
          defaultValue: moment().subtract(1, 'months').endOf('month').toISOString(),
          class: 'col-md-2'
        },
        'projects': {
          type: 'multiselect',
          name: 'Projects',
          nameItem: 'project_id',
          label: 'Projects',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-2'
        },
        'business_developers': {
          type: 'multiselect',
          name: 'business_developers',
          nameItem: 'business_developer_id',
          label: 'Business developers',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-2'
        },
        'invoice_statuses': {
          type: 'multiselect',
          name: 'invoice_statuses',
          nameItem: 'invoice_status_id',
          label: 'Invoice statuses',
          valueField: 'id',
          selectLabel: 'display_name',
          options: [],
          value: [],
          class: 'col-md-2'
        },
        'invoice_type': {
          type: 'multiselect',
          name: 'invoice_types',
          nameItem: 'invoice_type_id',
          label: 'Invoice type',
          valueField: 'id',
          selectLabel: 'type',
          options: [],
          value: [],
          defaultValue: [],
          validation: [
            { name: 'required' }
          ],
          class: 'col-md-2'
        }
      },
      selectedFilters: {},
      fieldsReportsSlot: {
        'specialist': {
          name: 'specialist'
        }
      },
      fieldsReports: [
        {
          key: 'specialist',
          label: 'Specialist',
          sortable: false,
          class: 'column-project-name'
        },
        {
          key: 'hours_amount',
          label: 'Hrs',
          sortable: true,
          class: 'column-hours'
        },
        {
          key: 'amount.RUB',
          label: 'RUB',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.GBP',
          label: 'GBP',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.UAH',
        //   label: 'Eq UAH',
        //   sortable: true,
        //   class: 'column-amount'
        // },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.EUR',
        //   label: 'Eq EUR',
        //   sortable: true,
        //   class: 'column-amount'
        // },
        {
          key: 'more',
          label: 'More',
          class: 'column-more'
        }
      ],
      fieldsReportsNested: [
        {
          key: 'project.name',
          label: 'Project name',
          sortable: true,
          class: 'column-project-name'
        },
        {
          key: 'hours_amount',
          label: 'Hrs',
          sortable: true,
          class: 'column-hours'
        },
        {
          key: 'amount.RUB',
          label: 'RUB',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.GBP',
          label: 'GBP',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.UAH',
        //   label: 'Eq UAH',
        //   sortable: true,
        //   class: 'column-amount'
        // },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.EUR',
        //   label: 'Eq EUR',
        //   sortable: true,
        //   class: 'column-amount'
        // },
        {
          key: 'more',
          label: 'More',
          class: 'column-more'
        }
      ],
      fieldsReportsTotal: [
        {
          key: 'total_name',
          class: 'column-bd-name'
        },
        {
          key: 'hours_amount',
          class: 'column-hours'
        },
        {
          key: 'amount.RUB',
          class: 'column-amount'
        },
        {
          key: 'amount.GBP',
          class: 'column-amount'
        },
        {
          key: 'amount.UAH',
          class: 'column-amount'
        },
        {
          key: 'amount.USD',
          class: 'column-amount'
        },
        {
          key: 'amount.EUR',
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.UAH',
        //   class: 'column-amount'
        // },
        {
          key: 'equivalent.USD',
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.EUR',
        //   class: 'column-amount'
        // },
        {
          key: 'more',
          class: 'column-more'
        }
      ],
      fieldsReportsInvoices: [
        {
          key: 'totalHours',
          label: 'Hours',
          sortable: true,
          class: 'column-hours'
        },
        {
          key: 'original.RUB',
          label: 'RUB',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.GBP',
          label: 'GBP',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.UAH',
        //   label: 'Eq UAH',
        //   sortable: true,
        //   class: 'column-amount'
        // },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.EUR',
        //   label: 'Eq EUR',
        //   sortable: true,
        //   class: 'column-amount'
        // },
        {
          key: 'paid_date',
          label: 'Paid date',
          sortable: true,
          class: 'column-number'
        },
        {
          key: 'due_date',
          label: 'Due date',
          sortable: true,
          class: 'column-number'
        },
        {
          key: 'issue_date',
          label: 'Issue date',
          sortable: true,
          class: 'column-number'
        },
        {
          key: 'invoice_status.name',
          label: 'Status',
          sortable: true,
          class: 'column-date text-center'
        },
        {
          key: 'invoice_type.type',
          label: 'Type',
          sortable: false,
          class: 'column-icon text-center'
        },
        {
          key: 'invoice_number',
          label: 'Invoice',
          sortable: false,
          class: 'column-date text-center'
        },
        {
          key: 'more',
          label: 'More',
          class: 'column-icon'
        }
      ],
      slotsPeriods: {
        specialist: {
          name: 'specialist'
        },
        period: {
          name: 'period'
        }
      },
      slotsItems: {
        specialist: {
          name: 'specialist'
        }
      },
      slotsInvoices: {
        invoice_number: {
          name: 'invoice_number'
        },
        'invoice_type.type': {
          name: 'invoice_type.type'
        },
        'invoice_status.name': {
          name: 'invoice_status.name'
        }
      },
      fieldsReportsItems: [
        {
          key: 'specialist',
          label: 'Specialist',
          sortable: false,
          class: 'column-bd-name'
        },
        {
          key: 'hour_cost',
          label: 'Hourly rate',
          sortable: true,
          class: 'column-hours'
        },
        {
          key: 'hours_amount',
          label: 'Hours',
          sortable: true,
          class: 'column-hours'
        },
        {
          key: 'amount.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.UAH',
        //   label: 'Eq UAH',
        //   sortable: true,
        //   class: 'column-amount'
        // },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        }
        // {
        //   key: 'equivalent.EUR',
        //   label: 'Eq EUR',
        //   sortable: true,
        //   class: 'column-amount'
        // }
      ],
      fieldsReportsPeriods: [
        {
          key: 'specialist',
          label: 'Specialist',
          sortable: false,
          class: 'column-bd-name'
        },
        {
          key: 'hours_amount',
          label: 'Hours',
          sortable: true,
          class: 'column-hours'
        },
        {
          key: 'amount.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.UAH',
        //   label: 'Eq UAH',
        //   sortable: true,
        //   class: 'column-amount'
        // },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.EUR',
        //   label: 'Eq EUR',
        //   sortable: true,
        //   class: 'column-amount'
        // },
        {
          key: 'period',
          label: 'Period',
          sortable: false,
          class: 'column-date'
        }
      ],
      fieldsReportsSpecialisations: [
        {
          key: 'specialisation.type_display_name',
          label: 'Specialisation',
          sortable: false,
          class: 'column-bd-name'
        },
        {
          key: 'hours',
          label: 'Hours',
          sortable: true,
          class: 'column-hours'
        },
        {
          key: 'amount.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        // {
        //   key: 'equivalent.UAH',
        //   label: 'Eq UAH',
        //   sortable: true,
        //   class: 'column-amount'
        // },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        }
        // {
        //   key: 'equivalent.EUR',
        //   label: 'Eq EUR',
        //   sortable: true,
        //   class: 'column-amount'
        // }
      ],
      fieldsReportsExtraPayments: [
        {
          key: 'cost',
          label: 'Cost',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false,
          class: 'column-bd-name'
        }
      ],
      reports: [],
      totalReports: [],
      columnDescription: [
        '<strong>AM</strong> = ',
        '<strong>Eg</strong> = ',
        '<strong>Type</strong> = ',
        '<strong>Invoice</strong> = '
      ]
    }
  },
  computed: {
    ...mapGetters({
      getProjects: 'projects/getProjects',
      getStatuses: 'finances/getStatuses',
      getBusinessDevelopers: 'businessDevelopers/getBusinessDevelopers',
      getInvoicesTypes: 'finances/getInvoicesTypes',
      getOwnBankDetails: 'finances/getOwnBankDetails',
      getTemplates: 'finances/getTemplates'
    }),
    getFieldsReports () {
      if (this.showColumns) {
        return this.fieldsReports
      } else {
        return this.getWithoutSomeColumns('fieldsReports')
      }
    },
    getFieldsReportsTotal () {
      if (this.showColumns) {
        return this.fieldsReportsTotal
      } else {
        return this.getWithoutSomeColumns('fieldsReportsTotal')
      }
    },
    getFieldsReportsInvoices () {
      if (this.showColumns) {
        return this.fieldsReportsInvoices
      } else {
        return this.getWithoutSomeColumns('fieldsReportsInvoices', 'original')
      }
    },
    getFieldsReportsNested () {
      if (this.showColumns) {
        return this.fieldsReportsNested
      } else {
        return this.getWithoutSomeColumns('fieldsReportsNested')
      }
    }
  },
  created () {
    this.fetchAllData()
  },
  methods: {
    disabledModalShowingButton (data) {
      if (data.item.invoice_type.id === 1) {
        return !data.item.items.length
      } else if (data.item.invoice_type.id === 2) {
        return !data.item.periods.length
      } else if (data.item.invoice_type.id === 3) {
        return !data.item.specialisations.length
      }
    },
    showDetails (data) {
      data.toggleDetails()
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    async saveFinanceInvoices (fields) {
      try {
        await this.saveInvoice(fields)
        this.getReportsInvoices()
      } finally {
        // Always turn off loading state
        if (this.$refs.financeInvoicesForm) {
          this.$refs.financeInvoicesForm.finishLoading()
        }
      }
    },
    handleInvoiceFormLoadingChange (loading) {
      // This method handles loading state changes from the invoice form
      // The loading state is now managed internally by the FinanceInvoicesForm component
    },
    fetchAllData () {
      Promise.all([
        this.fetchAllBankDetails(),
        this.fetchTemplates(),
        this.getAllProjects(),
        this.fetchAllUsers(),
        this.fetchBusinessDevelopers(),
        this.fetchInvoicesStatuses(),
        this.fetchInvoicesTypes()
      ])
        .then(() => {
          this.setAllOptionsFilter()
        })
    },
    async getReportsByFilter (fields) {
      this.selectedFilters = fields
      await this.getReportsInvoices()
      this.resetPagination()
    },
    resetPagination () {
      this.$refs['table'] && this.$refs['table'].resetPagination()
    },
    getReportsInvoices () {
      const data = this.prepareDataForGetReports(this.selectedFilters)

      return this._toggleDataPageLoading(() => {
        return this.$api.finances.getReportsInvoices(data).then((res) => {
          res.data.total.total_name = 'Total:'
          this.reports = res.data.collection
          this.totalReports = [res.data.total]
        }).catch((error) => {
          if (error.response) {
            this.errorNotifications(error)
          } else {
            throw error
          }
        })
      })
    },
    async getAllProjects () {
      await this.$api.projects.getProjects()
    },
    async fetchAllBankDetails () {
      return this.$api.finances.getBankDetailsAll()
    },
    async fetchTemplates () {
      return this.$api.finances.getInvoicesTemplate()
    },
    async fetchAllUsers () {
      return this.$api.users.getAllUsers()
    },
    async fetchInvoicesStatuses () {
      return this.$api.finances.getInvoicesStatuses()
    },
    async fetchInvoicesTypes () {
      return this.$api.finances.getInvoicesTypes()
    },
    async fetchBusinessDevelopers () {
      return this.$api.businessDevelopers.getBusinessDevelopers()
    },
    setAllOptionsFilter () {
      this.filters.projects.options = this.getProjects
      this.filters.invoice_statuses.options = this.getStatuses
      this.filters.business_developers.options = this.getBusinessDevelopers
      this.filters.invoice_type.options = this.getInvoicesTypes
      this.filters.invoice_type.value = this.getInvoicesTypes
      this.filters.invoice_type.defaultValue = this.getInvoicesTypes
    },
    prepareDataForGetReports (fields) {
      let newFields = fields
      let data = {}

      newFields.date_from.value = this._toLocalTime(newFields.date_from.value)
      newFields.date_to.value = this._toLocalTime(newFields.date_to.value)

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Array.isArray(value)) {
          value = value.map(item => {
            return {
              [fields[key].nameItem]: item.id
            }
          })
        }

        data[name] = value
      }

      return data
    },
    getWithoutSomeColumns (array, key = 'amount') {
      return this[array].filter(f => {
        return f.key !== `${key}.GBP` && f.key !== `${key}.RUB`
      })
    }
  }
}

</script>
